import { NotificationEnum } from "@graphql/generated/graphql.g";

export const NOTIFICATION_TYPE_LABELS: Record<NotificationEnum, string> = {
  [NotificationEnum.SharedLogin]: "Shared Login",
  [NotificationEnum.SaasDiscovered]: "SaaS Discovered",
  [NotificationEnum.FileUpload]: "File Upload",
  [NotificationEnum.NonWhitelistedEmail]: "Non-Whitelisted Email",
  [NotificationEnum.InactivityRecorded]: "Inactivity Recorded",
  [NotificationEnum.AccessToUnapprovedApp]: "Access to Unapproved App",
  [NotificationEnum.Signup]: "Signup",
};

export const ALL_NOTIFICATION_TYPES = Object.values(
  NotificationEnum,
) as NotificationEnum[];

export const NOTIFICATION_TYPE_OPTIONS = ALL_NOTIFICATION_TYPES.map((id) => ({
  id,
  label: NOTIFICATION_TYPE_LABELS[id],
}));

export const getNotificationTypeLabel = (
  notificationType: NotificationEnum | string | null | undefined,
): string => {
  if (!notificationType) {
    return "Unknown Notification Type";
  }

  return (
    NOTIFICATION_TYPE_LABELS[notificationType as NotificationEnum] ??
    "Unknown Notification Type"
  );
};
